export function getROIfromDecimalOdds(odds_s1, odds_s2, odds_s3, displayMode = false) {
  let stake_s1;
  if (odds_s3 != null) {
    stake_s1 = (odds_s2 + odds_s3) / (odds_s1 + odds_s2 + odds_s3)
  } else {
    stake_s1 = odds_s2 / (odds_s1 + odds_s2)
  }
  const payout = stake_s1 * odds_s1
  const profit = payout - 1
  const profit_percentage = profit * 100
  if (displayMode) {
    return `${profit_percentage.toFixed(2)}%`
  } else {
    return profit_percentage
  }
}

export function americanFromDecimal(dec, displayMode = false) {
  if (dec === null || dec === undefined) {
    return displayMode ? "NONE" : null;
  }
  if (dec > 2.0) {
    const value = (dec - 1) * 100;
    return displayMode ? `+${Math.round(value)}` : value;
  } else if (dec > 1.0) {
    const value = -100 / (dec - 1);
    return displayMode ? `${Math.round(value)}` : value;
  }
  return 0;
}

export function americanToDecimal(odds) {
  if (odds > 0) {
    return 1 + odds / 100;
  } else {
    return 1 - 100 / odds;
  }
}

export function spreadLineDisplay(line) {
  if (line > 0) {
    return `+${line}`
  } else {
    return `${line}`
  }
}

export function round(value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function calculateOptimalBets(site1_decimal, site2_decimal, stake1, precision, site3_decimal) {
  if (site3_decimal === null) {
    let stake2 = (site1_decimal * stake1) / site2_decimal;
    return {
      site1_bet: round(stake1, precision),
      site2_bet: round(stake2, precision),
      site3_bet: null,
    };
  } else {
    let stake2 = (site1_decimal * stake1) / site2_decimal;
    let stake3 = (site1_decimal * stake1) / site3_decimal;
    return {
      site1_bet: round(stake1, precision),
      site2_bet: round(stake2, precision),
      site3_bet: round(stake3, precision),
    };
  }
}

export function formatSite(site_id) {
  switch (site_id) {
    case "betmgm":
      return "BetMGM"
    case "betrivers":
      return "Betrivers"
    case "espnbet":
      return "ESPN Bet"
    case "fanduel":
      return "Fanduel"
    case "draftkings":
      return "Draftkings"
    case "prophetx":
      return "ProphetX"
    case "sporttrade (nj)":
      return "Sporttrade (NJ)"
    case "betonline":
      return "BetOnline"
    case "overtime (arbitrum)":
      return "Overtime (ARB)"
    case "overtime (optimism)":
      return "Overtime (OP)"
    case "overtime (base)":
      return "Overtime (BASE)"
    default:
      return capitalize(site_id)
  }
}

export function getLiquidityLabel(rating) {
  switch (rating) {
    case 0:
      return "VL"
    case 1:
      return "L"
    case 2:
      return "M"
    case 3:
      return "H"
    case 4:
      return "VH"
    default:
      return "VL"
  }
}

export function parseGameId(game_id, t1_id, t2_id, game_time_1, game_time_2) {
  const parts = game_id.split("-");

  if (parts.length < 4) {
    throw new Error("Invalid event string format");
  }

  const league = parts[0].toUpperCase();
  const team1 = t1_id.split("-").slice(1).join(" ");
  const team2 = t2_id.split("-").slice(1).join(" ");

  let timestamp;
  if (game_time_1 !== null && game_time_2 !== null) {
    timestamp = Math.min(game_time_1, game_time_2) * 1000;
  } else {
    timestamp = parseInt(parts[parts.length - 1], 10) * 1000;
  }

  const eventDate = new Date(timestamp);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const timeOptions = { hour: "numeric", minute: "2-digit", hour12: true };
  const formattedTime = eventDate.toLocaleTimeString("en-US", timeOptions);

  let formattedDate;
  if (eventDate >= today && eventDate < tomorrow) {
    formattedDate = `Today at ${formattedTime}`;
  } else if (eventDate >= tomorrow && eventDate < new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate() + 1)) {
    formattedDate = `Tomorrow at ${formattedTime}`;
  } else {
    const dateOptions = { month: "short", day: "numeric", year: "numeric" };
    formattedDate = `${eventDate.toLocaleDateString("en-US", dateOptions)} at ${formattedTime}`;
  }

  return {
    league,
    matchup: `${team1} vs ${team2}`,
    formattedTime: formattedDate
  };
}

export const getTimeAgo = (timestamp) => {
  const now = new Date();
  const past = new Date(timestamp);
  const seconds = Math.floor((now - past) / 1000);

  if (seconds < 60) {
    return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months} month${months !== 1 ? 's' : ''} ago`;
  }

  const years = Math.floor(months / 12);
  return `${years} year${years !== 1 ? 's' : ''} ago`;
};